/* OSKA COLLECTION FLOW — single breadcrumb & active family link, no duplicates */
(function(){
 'use strict';
 var page=document.body.dataset.oskaCollectionPage||'';
 var groups={
  'men-rings':{signet:['Geometrik Signet','Geometric Signet'],stone:['Taşlı','Gemstone Rings'],oxide:['Siyah Oksit','Black Oxide'],legends:['OSKA LEGENDS','OSKA LEGENDS']},
  'women-rings':{signet:['Signet','Signet'],stone:['Taşlı','Gemstone Rings'],geometric:['Geometrik','Geometric'],panther:['Panther','Panther']},
  'men-bracelets':{chain:['Zincir','Chain'],cuff:['Kelepçe','Cuff'],panther:['Panther','Panther'],chainmail:['Chainmail','Chainmail']},
  'women-bracelets':{chain:['Zincir','Chain'],tennis:['Tennis','Tennis'],cuff:['Kelepçe','Cuff']},
  'men-necklaces':{chain:['Zincir','Chain'],tag:['Dog Tag','Dog Tag'],panther:['Panther','Panther'],pendant:['Kolye Ucu','Pendants']},
  'women-necklaces':{chain:['Zincir','Chain'],tennis:['Tennis','Tennis'],pendant:['Kolye Ucu','Pendants'],panther:['Panther','Panther']},
  'men-earrings':{stud:['Stud','Stud'],hoop:['Hoop','Hoop']},
  'women-earrings':{stud:['Stud','Stud'],hoop:['Hoop','Hoop'],single:['Tekli','Single']}
 };
 if(!Object.prototype.hasOwnProperty.call(groups,page))return;
 var params=new URLSearchParams(location.search),key=(params.get('oska_collection')||'').toLowerCase();
 var labels=groups[page][key];if(!labels)return;
 // Women chain/tennis already receive a family breadcrumb from their existing template.
 // Preserve that path and do not append the same family again.
 if(page==='women-bracelets'&&(key==='chain'||key==='tennis')){
   document.body.dataset.oskaCollectionFlow='active';return;
 }
 var tr=(document.documentElement.lang||'').toLowerCase().startsWith('tr');
 function install(){
  var nav=document.querySelector('[data-oska-global-breadcrumb]');if(!nav)return;
  var curr=nav.querySelector('[data-oska-bc-current]');
  if(!curr)return;
  var name=labels[tr?0:1];
  // Another collection-specific template may have inserted the family crumb already.
  if(curr.textContent.trim().toLowerCase()===name.toLowerCase()){
   document.body.dataset.oskaCollectionFlow='active';return;
  }
  var root=(window.OSKA_ROOT||'/').replace(/\/$/,'');
  var parent=document.createElement('a');
  parent.href=root+'/pages/'+page;
  parent.textContent=curr.textContent.trim();
  parent.dataset.oskaBcParent='';
  curr.replaceWith(parent);
  var sep=document.createElement('span');sep.textContent='/';sep.setAttribute('aria-hidden','true');
  var label=document.createElement('strong');label.dataset.oskaBcCurrent='';label.textContent=name;
  nav.append(sep,label);
  document.body.dataset.oskaCollectionFlow='active';
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',install);
 else install();
})();
